import { render, staticRenderFns } from "./FlowUphold.vue?vue&type=template&id=797b98c3&scoped=true"
import script from "./FlowUphold.vue?vue&type=script&lang=ts"
export * from "./FlowUphold.vue?vue&type=script&lang=ts"
import style0 from "./FlowUphold.vue?vue&type=style&index=0&id=797b98c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b98c3",
  null
  
)

export default component.exports